import _findKey from 'lodash/findKey';
import {
  BACKGROUND_PATTERNS,
  getPatternWithColor,
} from '@wix/inbox-common/dist/src/background-patterns';
import { UPDATE_DESIGN, updateBackgroundPattern } from '../actions';
import utils from '../services/utils';
import { primaryColorOrDefault } from '../reducers';

const getBackgroundPattern = async ({ primaryColor, editorSettingsDesign }) => {
  const backgroundPatternKey = editorSettingsDesign.selectedBackgroundPattern;
  if (
    !backgroundPatternKey ||
    backgroundPatternKey === BACKGROUND_PATTERNS.NONE.key
  ) {
    const pattern = {
      asset: BACKGROUND_PATTERNS.NONE.getAsset(),
      backgroundSize: BACKGROUND_PATTERNS.NONE.backgroundSize,
    };
    return pattern;
  }
  {
    const backgroundPatternData =
      BACKGROUND_PATTERNS[
        (_findKey as any)(BACKGROUND_PATTERNS, ['key', backgroundPatternKey])
      ];
    const patternRgba = utils.getRgbA(
      primaryColor,
      backgroundPatternData.opacity,
    );

    const rawSvg = (
      await import(
        `@wix/inbox-common/dist/src/assets/backgroundPatterns/${backgroundPatternKey}.js`
      )
    ).default;
    const pattern = {
      asset: getPatternWithColor(rawSvg, patternRgba),
      backgroundSize: backgroundPatternData.backgroundSize,
    };
    return pattern;
  }
};

export const backgroundPatternMiddleware = ({
  getState,
  dispatch,
}) => next => async action => {
  switch (action.type) {
    case UPDATE_DESIGN:
      const pattern = await getBackgroundPattern({
        primaryColor: primaryColorOrDefault(getState()),
        editorSettingsDesign: action.design,
      });
      dispatch(updateBackgroundPattern(pattern));
      return next(action);
    default:
      return next(action);
  }
};
